import type { HTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router';
import { useLegacyAppLink } from '../../contexts/LegacyAppLinkContext';

interface RoccoLinkProps
    extends
        HTMLAttributes<HTMLAnchorElement>,
        Pick<
            LinkProps,
            'prefetch' | 'preventScrollReset' | 'viewTransition' | 'state'
        > {
    to: string;
    isNonRemixRoute?: boolean;
    newTab?: boolean;
}

export const RoccoLink = ({
    children,
    to,
    isNonRemixRoute = false,
    prefetch,
    preventScrollReset,
    viewTransition,
    state,
    newTab,
    ...props
}: RoccoLinkProps) => {
    const useLegacyLink = useLegacyAppLink();
    if (useLegacyLink || isNonRemixRoute) {
        return (
            <a
                href={to}
                {...props}
                target={newTab ? '_blank' : '_self'}
                rel={newTab ? 'noreferrer' : undefined}
            >
                {children}
            </a>
        );
    }

    return (
        <Link
            to={to}
            prefetch={prefetch}
            preventScrollReset={preventScrollReset}
            viewTransition={viewTransition}
            state={state}
            {...props}
            target={newTab ? '_blank' : '_self'}
            rel={newTab ? 'noreferrer' : undefined}
        >
            {children}
        </Link>
    );
};
